export default __webpack_public_path__ + "static/media/pinball_responsive.9dd5d2f2.png";